import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AdminPages.css';

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchReviews(); }, []);

  const fetchReviews = async () => {
    try {
      const res = await axios.get('/api/admin/reviews');
      setReviews(res.data);
    } catch (err) {
      console.error('Error fetching reviews:', err);
    } finally {
      setLoading(false);
    }
  };

  const toggleApproval = async (id, currentStatus) => {
    try {
      await axios.put(`/api/admin/reviews/${id}/status`, { approved: !currentStatus });
      fetchReviews();
    } catch (err) {
      alert('Error updating review');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this review?')) return;
    try {
      await axios.delete(`/api/admin/reviews/${id}`);
      fetchReviews();
    } catch (err) {
      alert('Error deleting review');
    }
  };

  if (loading) return <div className="admin-loading">Loading...</div>;

  return (
    <div className="admin-page admin-page-wide">
      <div className="admin-page-header">
        <div>
          <h2 className="admin-page-title">Reviews</h2>
          <p className="admin-page-desc">Manage product reviews and ratings. ({reviews.length} total)</p>
        </div>
      </div>

      <div className="admin-page-card admin-table-card">
        <div className="admin-notifications-table">
          <table>
            <thead>
              <tr><th>Customer</th><th>Material</th><th>Rating</th><th>Review</th><th>Status</th><th>Date</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {reviews.length === 0 ? (
                <tr><td colSpan="7" className="admin-no-data">No reviews yet.</td></tr>
              ) : reviews.map(r => (
                <tr key={r._id}>
                  <td><strong>{r.customerName || r.customerEmail}</strong></td>
                  <td>{r.materialName || '--'}</td>
                  <td>{'⭐'.repeat(r.rating || 0)}</td>
                  <td style={{ maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.comment}</td>
                  <td>
                    <span className={`admin-status-badge ${r.status === 'approved' ? 'admin-status-admin' : 'admin-status-pending'}`}>
                      {r.status || 'pending'}
                    </span>
                  </td>
                  <td>{new Date(r.createdAt).toLocaleDateString()}</td>
                  <td>
                    <div className="admin-action-buttons">
                      <button className="admin-btn-icon admin-btn-edit" onClick={() => toggleApproval(r._id, r.status === 'approved')}>
                        {r.status === 'approved' ? 'Reject' : 'Approve'}
                      </button>
                      <button className="admin-btn-icon admin-btn-delete" onClick={() => handleDelete(r._id)}>Delete</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Reviews;
